import { Title } from "App/Component/ui";
import React from "react";
import CounterKunjungan from "./CounterKunjungan";

export default function CounterWrapper() {
	return (
		<>
			<Title title="Satu Sehat - Encounter Condition" />

			<CounterKunjungan />
		</>
	);
}
